module.exports = __webpack_public_path__ + "static/media/do.2468708c.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/do.svg
// module id = 2079
// module chunks = 0